export default __webpack_public_path__ + "static/media/poster20.7979b843.png";